import { FIVE_SECONDS } from 'data/global';
import { useCallback, useRef, useState } from 'react';

const useUndoActions = () => {
  const [isUndoAvailable, setIsUndoAvailable] = useState(false);

  const timeoutRef = useRef(null);

  const setUndoTimeout = useCallback((onUndoTimeoutPass?: () => void) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setIsUndoAvailable(true);

    timeoutRef.current = setTimeout(() => {
      setIsUndoAvailable(false);
      onUndoTimeoutPass?.();
      timeoutRef.current = null;
    }, FIVE_SECONDS);
  }, []);

  const clearUndoTimeout = useCallback(() => {
    setIsUndoAvailable(false);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  return {
    isUndoAvailable,
    setUndoTimeout,
    clearUndoTimeout,
  };
};

export default useUndoActions;
